import _export from "../internals/export";
import _stringTrimStart from "../internals/string-trim-start";
var $ = _export;
var trimStart = _stringTrimStart;

// `String.prototype.trimLeft` method
// https://tc39.es/ecma262/#sec-string.prototype.trimleft
// eslint-disable-next-line es/no-string-prototype-trimleft-trimright -- safe
$({
  target: "String",
  proto: true,
  name: "trimStart",
  forced: "".trimLeft !== trimStart
}, {
  trimLeft: trimStart
});
export default {};